import React from "react";
import LocaleService from "../locale/LocaleService";
import TranslationRepository from "../repository/TranslationRepository";
import LaravelRepositoryAdapter from "../repository/LaravelRepositoryAdapter";

function LaravelTranslationService(props) {

    const adapterOptions = {
        namespace: props.namespace,
        resourceName: props.resourceName,
        operationName: props.operationName,
    }

    return (
        <LocaleService>
            <TranslationRepository adapter={new LaravelRepositoryAdapter(adapterOptions)}>
                <React.Fragment>
                    {props.children}
                </React.Fragment>
            </TranslationRepository>
        </LocaleService>
    );
}

LaravelTranslationService.defaultProps = {
    namespace: 'api',
    resourceName: 'env.translations',
    operationName: 'get_for_locale',
}

export default LaravelTranslationService;